import app from 'app';

import aboutUsColumns from './about/about-us-columns';
import aboutUsKeywordGallery from './about/about-us-keyword-gallery';
import aboutUsListCarousel from './about/about-us-list-carousel';
import aboutUsMenu from './about/about-us-menu';

app.add({
  'about-us-menu': aboutUsMenu,
  'about-us-columns': aboutUsColumns,
  'about-us-keyword-gallery': aboutUsKeywordGallery,
  'about-us-list-carousel': aboutUsListCarousel,
});
